<template>
  <div class="home">
    <nav-icon />
    <div class="main-bg">
      <home-page />
      <hr class="main-hr" />
      <event-page />
    </div>
    <registration-page />
  </div>
</template>

<script>
import HomePage from "@/components/HomePage.vue";
import EventPage from "@/components/EventPage.vue";
import RegistrationPage from "@/components/RegistrationPage.vue";
import NavIcon from "@/components/NavIcon.vue";

export default {
  name: "home",
  components: {
    HomePage,
    EventPage,
    RegistrationPage,
    NavIcon
  }
};
</script>

<style>
.main-bg {
  background: var(--bg);
  background: linear-gradient(
    to bottom right,
    var(--bg-dark),
    var(--bg) 30% 70%,
    var(--bg-dark)
  );
}

.main-hr {
  background-color: var(--bg-dark) !important;
  color: var(--bg-dark) !important;
  border: solid 0px var(--bg-dark) !important;
}

hr {
  margin: 0 1rem;
  background-color: #cccccc !important;
  box-shadow: none;
  color: #cccccc !important;
  outline: none;
  border: solid 0px #cccccc !important;
  height: 1px !important;
}

body {
  margin: 0;
  padding: 0;
  color: #cdcdcd;
}

a {
  text-decoration: none;
  color: var(--font);
  transition: color 0.3s ease;
}

a:hover {
  color: var(--font-dark);
}

.card {
  display: inline-block;
  background: white;
  border-radius: 0.5rem;
  color: black;
  padding: 1em 0;
  background: white;
  background: linear-gradient(to bottom right, #aaaaaa, #ffffff 30% 80%, #aaaaaa);
  box-shadow: 0px 0px 1rem 0.1em rgba(161, 161, 161, 0.329);
}

.title {
  font-size: 1.5rem;
  text-align: start;
  padding-left: 1rem;
  padding-top: 0.5rem;
  padding-bottom: 0.2rem;
  text-shadow: 5rem black;
  color: var(--font);
}
</style>

